<div>
  <h6 class="odx-title-6" i18n="@@global.wildcardZones">Variable Zonen</h6>

  <app-floorplan-menu-item-buttons>
    @for (zoneType of [WildcardZoneType.ZONE_0, WildcardZoneType.ZONE_1, WildcardZoneType.ZONE_2]; track zoneType) {
      <button
        odxButton
        [ngClass]="`wildcard-${$index}`"
        (click)="addWildcardZone(zoneType)"
        [odxTooltip]="tooltipTextAddWildcardZone($index)"
        [odxTooltipOptions]="{ position: 'bottom-start' }"
        draggable="true"
        (dragstart)="dragWildcardZone(zoneType)"
      >
        <odx-icon name="plus" size="medium"></odx-icon>
      </button>
    }
    <app-toggle-visibility-button
      [visible]="floorplanState.wildcardZonesVisible"
      (toggleEvent)="floorplanState.wildcardZonesVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.wildcardZonesItemTextVisible"
      (toggleEvent)="updateWildcardZonesItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button
      [locked]="floorplanState.wildcardZonesLocked"
      (toggleEvent)="floorplanState.wildcardZonesLocked = $event"
    >
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
